// Helper for detecting if the app is in an iFrame
// https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
export const isInIFrame = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
